import React, { useState } from 'react';
import './Products.css';
import './AllSellStyles.css';
import './CommonStyles.css';
import { exportToCSV, exportToExcel, exportToPDF, printPage } from './exportUtils';

const ServiceStaffReport = () => {
    const [entriesPerPage, setEntriesPerPage] = useState(25);
    const [searchTerm, setSearchTerm] = useState('');
    const [showExportDropdown, setShowExportDropdown] = useState(false);
    const [activeSubTab, setActiveSubTab] = useState('orders');

    // Sub-tabs for the report
    const subTabs = [
        { id: 'orders', label: 'Orders' },
        { id: 'line-orders', label: 'Line Orders' },
    ];

    // No data available as per the screenshot
    const mockData = [];

    const handleExport = (format) => {
        const headers = ['Date', 'Invoice No.', 'Service staff', 'Location', 'Subtotal', 'Total Discount', 'Total Tax', 'Total amount'];
        const rows = mockData.map(r => [
            r.date || '',
            r.invoiceNo || '',
            r.serviceStaff || '',
            r.location || '',
            r.subtotal || '$ 0.00',
            r.totalDiscount || '$ 0.00',
            r.totalTax || '$ 0.00',
            r.totalAmount || '$ 0.00'
        ]);

        const title = 'Service Staff Report';
        const filename = 'service_staff_report';

        if (format === 'CSV') exportToCSV(headers, rows, filename);
        else if (format === 'Excel') exportToExcel(headers, rows, filename);
        else if (format === 'PDF') exportToPDF(title, headers, rows, filename);
        else if (format === 'Print') printPage();

        setShowExportDropdown(false);
    };

    return (
        <div style={{ paddingTop: '0.5rem' }}>

            {/* ── Service Staff Table Container ── */}
            <div style={{
                background: '#fff',
                border: '1px solid #e2e8f0',
                borderRadius: '10px',
                overflow: 'hidden',
                boxShadow: '0 1px 3px rgba(0,0,0,0.06)'
            }}>

                {/* Sub-tabs */}
                <div style={{ display: 'flex', borderBottom: '1px solid #e2e8f0', background: '#fff' }}>
                    {subTabs.map(tab => (
                        <button
                            key={tab.id}
                            onClick={() => setActiveSubTab(tab.id)}
                            style={{
                                padding: '1rem 1.25rem',
                                background: 'none',
                                border: 'none',
                                borderTop: activeSubTab === tab.id ? '2px solid #3b82f6' : '2px solid transparent',
                                color: activeSubTab === tab.id ? '#1e293b' : '#64748b',
                                fontWeight: activeSubTab === tab.id ? '700' : '600',
                                fontSize: '0.85rem',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5rem',
                                transition: 'all 0.2s',
                            }}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>

                {/* Table controls */}
                <div className="table-controls" style={{ borderBottom: '1px solid #e2e8f0', padding: '1rem 1.25rem' }}>
                    <div className="table-controls-left">
                        <div className="entries-select">
                            <span>Show</span>
                            <select value={entriesPerPage} onChange={e => setEntriesPerPage(Number(e.target.value))}>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>
                            <span>entries</span>
                        </div>
                    </div>

                    <div className="table-controls-right">
                        {/* Single Export dropdown */}
                        <div className="export-dropdown-container" style={{ position: 'relative' }}>
                            <button
                                className="export-btn"
                                onClick={() => setShowExportDropdown(!showExportDropdown)}
                                style={{
                                    display: 'flex', alignItems: 'center', gap: '0.4rem',
                                    padding: '0.4rem 0.8rem', border: '1px solid #e2e8f0',
                                    borderRadius: '6px', background: '#fff', cursor: 'pointer',
                                    fontSize: '0.85rem', color: '#334155'
                                }}
                            >
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                    <polyline points="7 10 12 15 17 10" />
                                    <line x1="12" y1="15" x2="12" y2="3" />
                                </svg>
                                Export ▾
                            </button>
                            {showExportDropdown && (
                                <div className="export-dropdown-menu" style={{
                                    position: 'absolute', top: '100%', right: 0, marginTop: '0.25rem',
                                    background: '#fff', border: '1px solid #e2e8f0', borderRadius: '6px',
                                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)', zIndex: 10, minWidth: '160px'
                                }}>
                                    {[
                                        { icon: 'fa-file-excel-o', label: 'Export CSV', action: () => handleExport('CSV') },
                                        { icon: 'fa-file-excel-o', label: 'Export Excel', action: () => handleExport('Excel') },
                                        { icon: 'fa-print', label: 'Print', action: () => handleExport('Print') },
                                        { icon: 'fa-table', label: 'Column visibility' },
                                        { icon: 'fa-file-pdf-o', label: 'Export PDF', action: () => handleExport('PDF') },
                                    ].map((item, i) => (
                                        <button
                                            key={i}
                                            onClick={() => { if (item.action) item.action(); else setShowExportDropdown(false); }}
                                            style={{
                                                display: 'flex', alignItems: 'center', gap: '0.5rem',
                                                width: '100%', padding: '0.5rem 1rem', border: 'none',
                                                background: 'none', textAlign: 'left', cursor: 'pointer',
                                                fontSize: '0.8125rem', color: '#475569'
                                            }}
                                            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f1f5f9'}
                                            onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                                        >
                                            <i className={`fa ${item.icon}`} style={{ width: '14px', textAlign: 'center' }} />
                                            {item.label}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* Search */}
                        <input
                            type="text"
                            placeholder="Search ..."
                            value={searchTerm}
                            onChange={e => setSearchTerm(e.target.value)}
                            style={{
                                padding: '0.4rem 0.75rem',
                                border: '1px solid #e2e8f0',
                                borderRadius: '6px',
                                fontSize: '0.8125rem',
                                outline: 'none',
                                width: '180px',
                            }}
                        />
                    </div>
                </div>

                {/* Table */}
                <div style={{ overflowX: 'auto', paddingBottom: '0.5rem' }}>
                    <table className="products-table" style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                        <thead>
                            <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '700' }}>Date <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '700' }}>Invoice No. <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '700' }}>Service staff <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '700' }}>Location <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '700' }}>Subtotal <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '700' }}>Total Discount <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '700' }}>Total Tax <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} /></th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '700' }}>Total amount <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} /></th>
                            </tr>
                        </thead>
                        <tbody>
                            {mockData.length > 0 ? (
                                mockData.map((row, idx) => (
                                    <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                                        <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569' }}>{row.date}</td>
                                        <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569' }}>{row.invoiceNo}</td>
                                        <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569' }}>{row.serviceStaff}</td>
                                        <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569' }}>{row.location}</td>
                                        <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569' }}>{row.subtotal}</td>
                                        <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569' }}>{row.totalDiscount}</td>
                                        <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569' }}>{row.totalTax}</td>
                                        <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569' }}>{row.totalAmount}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr style={{ borderBottom: '1px solid #f1f5f9' }}>
                                    <td colSpan="8" style={{ padding: '1rem', textAlign: 'center', fontSize: '0.85rem', color: '#64748b' }}>
                                        No data available in table
                                    </td>
                                </tr>
                            )}
                            {/* Footer Total Row */}
                            <tr style={{ background: '#cbd5e1', borderTop: '2px solid #e2e8f0', fontWeight: '700' }}>
                                <td colSpan="4" style={{ padding: '0.75rem 1rem', textAlign: 'center', fontSize: '0.85rem', color: '#0f172a' }}>Total:</td>
                                <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569' }}>$ 0.00</td>
                                <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569' }}>$ 0.00</td>
                                <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569' }}>$ 0.00</td>
                                <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569' }}>$ 0.00</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination" style={{ padding: '0.85rem 1.25rem', borderTop: '1px solid #e2e8f0' }}>
                    <div className="pagination-info" style={{ fontSize: '0.8125rem' }}>
                        Showing 0 to 0 of 0 entries
                    </div>
                    <div className="pagination-controls">
                        <button className="page-btn disabled">Previous</button>
                        <button className="page-btn disabled">Next</button>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default ServiceStaffReport;
